import { render, staticRenderFns } from "./VoiceSearchBar.vue?vue&type=template&id=1b9e75cc&scoped=true&"
import script from "./VoiceSearchBar.vue?vue&type=script&lang=js&"
export * from "./VoiceSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSearchBar.vue?vue&type=style&index=0&id=1b9e75cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e75cc",
  null
  
)

export default component.exports